/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CorrectBehavioralAssessmentForSurveyUser$Params {
  surveyUserGuid: string;
}

export function correctBehavioralAssessmentForSurveyUser(http: HttpClient, rootUrl: string, params: CorrectBehavioralAssessmentForSurveyUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, correctBehavioralAssessmentForSurveyUser.PATH, 'post');
  if (params) {
    rb.path('surveyUserGuid', params.surveyUserGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

correctBehavioralAssessmentForSurveyUser.PATH = '/behavioralAssessment/data-correction/survey-user/{surveyUserGuid}';
